module.exports = __webpack_public_path__ + "img/message.af1bef78.svg";